<template>
  <div class="search-container" ref="searchContainer" v-click-outside="closeDropdown" :class="{focused: dropdownOpen}">
    <div class="input-container">
        <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="path-1-inside-1_2741_316" fill="white">
            <path d="M14.6044 15.1024C14.4784 15.2285 14.3288 15.3285 14.1641 15.3967C13.9995 15.4649 13.823 15.5 13.6447 15.5C13.4665 15.5 13.29 15.4649 13.1254 15.3967C12.9607 15.3285 12.8111 15.2285 12.6851 15.1024L8.63789 11.0562C8.37804 11.2138 8.10574 11.3499 7.82371 11.4632C6.60672 11.9552 5.25699 12.0114 4.00328 11.6223C2.74956 11.2332 1.66898 10.4227 0.944643 9.3281C0.22031 8.23355 -0.103214 6.92228 0.0288984 5.61651C0.161011 4.31075 0.740633 3.09081 1.66954 2.16344C2.59844 1.23608 3.81949 0.658319 5.12575 0.528086C6.43201 0.397855 7.74313 0.723158 8.83692 1.44887C9.93071 2.17458 10.7399 3.25605 11.1273 4.51002C11.5148 5.76398 11.4566 7.11331 10.9628 8.32932C10.8498 8.60906 10.7136 8.87887 10.5557 9.1359L14.6044 13.1829C14.8578 13.4375 15 13.782 15 14.1412C15 14.5003 14.8578 14.8449 14.6044 15.0995M2.48193 9.38972C3.22332 10.1311 4.19889 10.5924 5.2424 10.6953C6.28591 10.7981 7.33279 10.5359 8.20466 9.95353C9.07652 9.37113 9.7194 8.5045 10.0238 7.50132C10.3281 6.49813 10.2751 5.42047 9.87381 4.45198C9.47249 3.48348 8.74767 2.68408 7.82287 2.18999C6.89807 1.6959 5.83052 1.5377 4.80213 1.74235C3.77373 1.947 2.84814 2.50183 2.18307 3.3123C1.518 4.12277 1.15461 5.13873 1.15482 6.18704C1.15498 7.38829 1.63234 8.54029 2.48193 9.38972Z"/>
            </mask>
            <path d="M14.6044 15.1024C14.4784 15.2285 14.3288 15.3285 14.1641 15.3967C13.9995 15.4649 13.823 15.5 13.6447 15.5C13.4665 15.5 13.29 15.4649 13.1254 15.3967C12.9607 15.3285 12.8111 15.2285 12.6851 15.1024L8.63789 11.0562C8.37804 11.2138 8.10574 11.3499 7.82371 11.4632C6.60672 11.9552 5.25699 12.0114 4.00328 11.6223C2.74956 11.2332 1.66898 10.4227 0.944643 9.3281C0.22031 8.23355 -0.103214 6.92228 0.0288984 5.61651C0.161011 4.31075 0.740633 3.09081 1.66954 2.16344C2.59844 1.23608 3.81949 0.658319 5.12575 0.528086C6.43201 0.397855 7.74313 0.723158 8.83692 1.44887C9.93071 2.17458 10.7399 3.25605 11.1273 4.51002C11.5148 5.76398 11.4566 7.11331 10.9628 8.32932C10.8498 8.60906 10.7136 8.87887 10.5557 9.1359L14.6044 13.1829C14.8578 13.4375 15 13.782 15 14.1412C15 14.5003 14.8578 14.8449 14.6044 15.0995M2.48193 9.38972C3.22332 10.1311 4.19889 10.5924 5.2424 10.6953C6.28591 10.7981 7.33279 10.5359 8.20466 9.95353C9.07652 9.37113 9.7194 8.5045 10.0238 7.50132C10.3281 6.49813 10.2751 5.42047 9.87381 4.45198C9.47249 3.48348 8.74767 2.68408 7.82287 2.18999C6.89807 1.6959 5.83052 1.5377 4.80213 1.74235C3.77373 1.947 2.84814 2.50183 2.18307 3.3123C1.518 4.12277 1.15461 5.13873 1.15482 6.18704C1.15498 7.38829 1.63234 8.54029 2.48193 9.38972Z" fill="#333333"/>
            <path d="M13.6447 15.5L13.6447 16.5L13.6447 15.5ZM12.6851 15.1024L13.3923 14.3955L13.3921 14.3953L12.6851 15.1024ZM8.63789 11.0562L9.34492 10.349L8.7901 9.7943L8.1193 10.2012L8.63789 11.0562ZM7.82371 11.4632L7.45103 10.5352L7.44889 10.5361L7.82371 11.4632ZM10.9628 8.32932L10.0362 7.95303L10.0355 7.95492L10.9628 8.32932ZM10.5557 9.1359L9.7037 8.61231L9.29029 9.28498L9.84871 9.84316L10.5557 9.1359ZM14.6044 13.1829L15.3132 12.4775L15.3113 12.4757L14.6044 13.1829ZM15 14.1412L16 14.1412L15 14.1412ZM1.15482 6.18704L2.15482 6.18691L2.15482 6.18684L1.15482 6.18704ZM13.8971 14.3955C13.864 14.4286 13.8247 14.4549 13.7814 14.4728L14.5469 16.3205C14.8329 16.202 15.0927 16.0284 15.3116 15.8094L13.8971 14.3955ZM13.7814 14.4728C13.7381 14.4908 13.6916 14.5 13.6447 14.5L13.6447 16.5C13.9543 16.5 14.2609 16.439 14.5469 16.3205L13.7814 14.4728ZM13.6447 14.5C13.5979 14.5 13.5514 14.4908 13.5081 14.4728L12.7426 16.3205C13.0286 16.439 13.3352 16.5 13.6447 16.5L13.6447 14.5ZM13.5081 14.4728C13.4648 14.4549 13.4255 14.4286 13.3923 14.3955L11.9779 15.8094C12.1968 16.0284 12.4566 16.202 12.7426 16.3205L13.5081 14.4728ZM13.3921 14.3953L9.34492 10.349L7.93087 11.7634L11.9781 15.8096L13.3921 14.3953ZM8.1193 10.2012C7.90602 10.3305 7.68252 10.4422 7.45103 10.5352L8.1964 12.3911C8.52897 12.2576 8.85007 12.0971 9.15649 11.9112L8.1193 10.2012ZM7.44889 10.5361C6.44573 10.9416 5.33314 10.988 4.2997 10.6672L3.70685 12.5774C5.18084 13.0348 6.7677 12.9687 8.19853 12.3903L7.44889 10.5361ZM4.2997 10.6672C3.26626 10.3465 2.37559 9.6784 1.77858 8.77624L0.110709 9.87997C0.962365 11.1669 2.23286 12.1199 3.70685 12.5774L4.2997 10.6672ZM1.77858 8.77624C1.18157 7.87409 0.914935 6.79335 1.02382 5.71718L-0.966022 5.51585C-1.12136 7.0512 -0.740951 8.593 0.110709 9.87997L1.77858 8.77624ZM1.02382 5.71718C1.1327 4.641 1.61042 3.63551 2.37606 2.87114L0.963014 1.45575C-0.129151 2.54611 -0.810682 3.9805 -0.966022 5.51585L1.02382 5.71718ZM2.37606 2.87114C3.1417 2.10675 4.14819 1.63051 5.22495 1.52315L5.02654 -0.46698C3.49079 -0.313868 2.05518 0.365396 0.963014 1.45575L2.37606 2.87114ZM5.22495 1.52315C6.30172 1.4158 7.38248 1.68396 8.28406 2.28214L9.38978 0.615593C8.10378 -0.237643 6.56229 -0.620093 5.02654 -0.46698L5.22495 1.52315ZM8.28406 2.28214C9.18564 2.88032 9.85257 3.77171 10.1719 4.80522L12.0828 4.21482C11.6272 2.74039 10.6758 1.46883 9.38978 0.615593L8.28406 2.28214ZM10.1719 4.80522C10.4912 5.83872 10.4433 6.9508 10.0363 7.95303L11.8893 8.7056C12.4699 7.27581 12.5383 5.68925 12.0828 4.21482L10.1719 4.80522ZM10.0355 7.95492C9.94343 8.18292 9.83245 8.40281 9.7037 8.61231L11.4076 9.6595C11.5948 9.35492 11.7562 9.03521 11.89 8.70371L10.0355 7.95492ZM9.84871 9.84316L13.8974 13.8902L15.3113 12.4757L11.2626 8.42865L9.84871 9.84316ZM13.8956 13.8883C13.9625 13.9556 14 14.0465 14 14.1412L16 14.1412C16 13.5176 15.753 12.9195 15.3132 12.4775L13.8956 13.8883ZM14 14.1412C14 14.2359 13.9625 14.3268 13.8956 14.3941L15.3132 15.8049C15.753 15.3629 16 14.7648 16 14.1412L14 14.1412ZM1.77485 10.0968C2.67984 11.0018 3.87065 11.5649 5.14435 11.6904L5.34044 9.70007C4.52712 9.61994 3.7668 9.26034 3.18902 8.68259L1.77485 10.0968ZM5.14435 11.6904C6.41805 11.8159 7.69589 11.496 8.76012 10.7851L7.64919 9.12199C6.9697 9.57589 6.15377 9.7802 5.34044 9.70007L5.14435 11.6904ZM8.76012 10.7851C9.82435 10.0742 10.6091 9.01628 10.9807 7.79165L9.06684 7.21099C8.82966 7.99272 8.32868 8.6681 7.64919 9.12199L8.76012 10.7851ZM10.9807 7.79165C11.3522 6.56701 11.2875 5.25145 10.7976 4.06916L8.94999 4.83479C9.26272 5.5895 9.30401 6.42926 9.06684 7.21099L10.9807 7.79165ZM10.7976 4.06916C10.3077 2.88688 9.42294 1.91108 8.2941 1.30798L7.35164 3.072C8.0724 3.45708 8.63725 4.08008 8.94999 4.83479L10.7976 4.06916ZM8.2941 1.30798C7.16527 0.704881 5.86221 0.511789 4.60695 0.761582L4.9973 2.72312C5.79883 2.56362 6.63088 2.68692 7.35164 3.072L8.2941 1.30798ZM4.60695 0.761582C3.3517 1.01138 2.22187 1.68861 1.41003 2.67795L2.95611 3.94666C3.4744 3.31505 4.19577 2.88262 4.9973 2.72312L4.60695 0.761582ZM1.41003 2.67795C0.598177 3.66728 0.15456 4.9075 0.154817 6.18725L2.15482 6.18684C2.15465 5.36996 2.43782 4.57826 2.95611 3.94666L1.41003 2.67795ZM0.154817 6.18718C0.155012 7.65366 0.737783 9.05999 1.7749 10.0969L3.18897 8.68255C2.5269 8.0206 2.15494 7.12292 2.15482 6.18691L0.154817 6.18718Z" fill="#333333" mask="url(#path-1-inside-1_2741_316)"/>
        </svg>

        <input :class="{focused: dropdownOpen}" :placeholder="toLocal('generic.search')" type="text" v-model="searchInput" @focus="openDropdown"/>
    </div>
    <transition name="slide-fade">
        <div 
            class="dropdown-container" 
            v-if="dropdownOpen"
            @mouseover="isHoveringDropdown=true"
            @mouseleave="isHoveringDropdown=false"
            v-scroll-lock="isHoveringDropdown"
        >
            <div class="dropdown" ref="dropdown" :style="{'max-height': maxHeight+'px'}" @scroll="onScroll" >
                <div
                    class="dropdown-section" 
                    v-for="(type, i_t) in itemOrder" 
                    :key="i_t"
                    :class="{'bb-2': i_t == 0 && items[type].length > 0, 'training-groups-section': i_t ==0}"
                >
                    <div 
                        class="found-items"
                        v-if="i_t == 2 ? totalTrainingCount : i_t == 0 ? items[type].length : totalTrainingDeepCount"
                    >
                    {{i_t == 0 ? 
                        toLocal('search.folders_found')+':' 
                        : i_t == 2 ? toLocal('search.trainings_found')+':'
                        : toLocal('search.trainings_found_deep')+':'}} 
                    {{ 
                        i_t == 0 
                        ? items[type].length 
                        : i_t == 2 
                        ? totalTrainingCount 
                        : totalTrainingDeepCount
                    }}
                    </div>
                   
                    <div 
                        class="item" 
                        v-for="(item, index) in items[type]" 
                        :key="index"
                        @click="openItem(item,type)"
                    >
                        <div 
                            class="icon" 
                            :style="{'background-image': ['trainings', 'trainings_deep'].includes(type) ? item.cover ? `url('${getFileUrl(item.cover)}')` : 'url('+require('@/assets/images/placeholders/pia21974.0.jpg')+')' : ''}"
                        >
                            <svg v-if="type=='training_groups'" width="40" height="32" viewBox="0 0 40 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path :style="{fill: item.color}" d="M34.0082 10.3005V7.297C34.0318 6.73791 33.8508 6.19144 33.505 5.7773C33.1592 5.36317 32.6767 5.11514 32.1633 5.08755H17.3308C17.1185 5.08711 16.9128 5.0066 16.7488 4.85973L12.9711 1.4586C12.8071 1.31173 12.6014 1.23123 12.3891 1.23078H2.66299C2.46379 1.23516 2.26733 1.28223 2.08484 1.36929C1.90235 1.45635 1.7374 1.58171 1.59942 1.73819C1.46144 1.89467 1.35312 2.07921 1.28067 2.28128C1.20821 2.48335 1.17303 2.69897 1.17714 2.91584V28.5598C1.1672 28.997 1.27676 29.4276 1.49191 29.797C1.70706 30.1663 2.01812 30.4578 2.38563 30.6344C2.58701 30.7234 2.80227 30.7691 3.01959 30.7692H32.1633" fill="#1870F3"/>
                                <path  fill-rule="evenodd" clip-rule="evenodd" d="M2.66299 0H12.3914C12.8887 0.0010382 13.3636 0.189903 13.7363 0.523695L13.7385 0.525718L17.4384 3.85677H32.1633C32.1834 3.85677 32.2035 3.85731 32.2236 3.85839C33.0632 3.9035 33.841 4.30879 34.3911 4.9676C34.9335 5.61716 35.2137 6.46241 35.1847 7.32111V10.3005C35.1847 10.9802 34.658 11.5312 34.0082 11.5312C33.3584 11.5312 32.8317 10.9802 32.8317 10.3005V7.297C32.8317 7.27893 32.8321 7.26085 32.8328 7.2428C32.8433 6.99363 32.7618 6.75813 32.6189 6.58701C32.4832 6.42442 32.3053 6.33426 32.1257 6.31833H17.3308L17.3284 6.31833C16.8312 6.3173 16.3563 6.12843 15.9836 5.79464L15.9814 5.79261L12.2815 2.46157H2.68018C2.64456 2.46335 2.60833 2.47227 2.57301 2.48912C2.53508 2.50722 2.49763 2.53478 2.4642 2.5727C2.43067 2.61072 2.40208 2.65821 2.38224 2.71355C2.36237 2.76896 2.35226 2.82957 2.35343 2.89147L2.35389 2.91584L2.35366 28.5598L2.35333 28.589C2.34869 28.7932 2.40015 28.9909 2.49659 29.1565C2.58888 29.3149 2.71635 29.4341 2.8588 29.5071C2.91155 29.5281 2.966 29.5384 3.01999 29.5384H32.1633C32.813 29.5384 33.3398 30.0895 33.3398 30.7692C33.3398 31.449 32.813 32 32.1633 32H3.01959C2.64425 31.9999 2.27318 31.9207 1.92797 31.7683C1.91673 31.7633 1.90556 31.7581 1.89447 31.7528C1.30913 31.4715 0.821371 31.011 0.487229 30.4374C0.15605 29.8689 -0.0115688 29.2115 0.000620358 28.5467V2.9264C-0.00468734 2.55919 0.0556063 2.19341 0.1791 1.84901C0.304166 1.50022 0.492199 1.17862 0.734637 0.903678C0.977166 0.628633 1.26962 0.405485 1.59666 0.24946C1.92383 0.0933764 2.27789 0.008197 2.63826 0.000271844L2.66299 0Z" fill="white"/>
                                <path :style="{fill: item.color}" d="M37.5713 10.2993H7.48904C7.21507 10.3139 6.95295 10.4254 6.74245 10.6168C6.53195 10.8083 6.38456 11.0693 6.32265 11.3602L1.71775 28.7177C1.64462 28.9359 1.61797 29.1694 1.63983 29.4005C1.66168 29.6316 1.73147 29.8543 1.84391 30.0518C1.95636 30.2492 2.10853 30.4163 2.28894 30.5404C2.46936 30.6645 2.6733 30.7423 2.88538 30.7681H32.9651C33.2391 30.7535 33.5012 30.642 33.7117 30.4505C33.9222 30.259 34.0696 29.9981 34.1315 29.7071L38.7377 12.351C38.811 12.1328 38.8379 11.8993 38.8162 11.6681C38.7945 11.4369 38.7249 11.2141 38.6126 11.0165C38.5002 10.8189 38.3481 10.6516 38.1677 10.5274C37.9874 10.4032 37.7834 10.3252 37.5713 10.2993Z" fill="#1870F3"/>
                                <path  fill-rule="evenodd" clip-rule="evenodd" d="M7.42923 9.07009C7.44915 9.06903 7.46909 9.0685 7.48904 9.0685H37.5713C37.6168 9.0685 37.6623 9.07127 37.7075 9.07678C38.1042 9.12516 38.4827 9.27077 38.8147 9.49942C39.1465 9.72792 39.4221 10.0326 39.6238 10.3874C39.8254 10.742 39.9487 11.1388 39.9871 11.5479C40.024 11.9413 39.9816 12.3392 39.8622 12.7144L35.2721 30.0105C35.1523 30.5383 34.8794 31.0194 34.4837 31.3793C34.0782 31.7481 33.5665 31.9684 33.0249 31.9972C33.005 31.9983 32.9851 31.9988 32.9651 31.9988H2.88538C2.84007 31.9988 2.7948 31.9961 2.74979 31.9906C2.35319 31.9425 1.97467 31.7972 1.64262 31.5688C1.3108 31.3406 1.03504 31.0362 0.833158 30.6817C0.631361 30.3273 0.5077 29.9307 0.469025 29.5217C0.431818 29.1282 0.473902 28.7302 0.593038 28.3548L5.18211 11.0569C5.30182 10.5291 5.57476 10.048 5.97049 9.68802C6.37595 9.31923 6.88768 9.09893 7.42923 9.07009ZM7.54007 11.5301C7.53337 11.5321 7.52453 11.5364 7.51441 11.5456C7.49806 11.5605 7.47955 11.5877 7.47105 11.6277C7.46664 11.6484 7.46173 11.6689 7.45631 11.6893L2.85142 29.0468C2.84446 29.0731 2.83666 29.0991 2.82804 29.1248C2.8119 29.173 2.8056 29.2261 2.81063 29.2794C2.81567 29.3326 2.83157 29.3813 2.85467 29.4219C2.87767 29.4623 2.90626 29.492 2.93526 29.5119C2.95187 29.5234 2.96867 29.5317 2.98521 29.5373H32.9141C32.9208 29.5353 32.9297 29.5309 32.9398 29.5217C32.9561 29.5068 32.9746 29.4796 32.9831 29.4397C32.9875 29.4189 32.9925 29.3983 32.9979 29.3779L37.604 12.0218C37.6111 11.9952 37.619 11.9688 37.6278 11.9427C37.6439 11.8946 37.6503 11.8415 37.6453 11.7882C37.6403 11.7349 37.6244 11.6862 37.6014 11.6456C37.5784 11.6052 37.5498 11.5754 37.5208 11.5554C37.5042 11.544 37.4874 11.5357 37.471 11.5301H7.54007Z" fill="white"/>
                            </svg>

                        </div>
                        <div class="content">
                            <span v-if="type=='trainings_deep'">
                                <p v-if="item && item.matches && item.matches[0].text" v-html="item.matches[0].text"></p>
                            </span>
                            <span v-else>
                                {{ item.name }}
                            </span>
                            <span class="training-group" v-if="type=='trainings'">
                                <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M17.6248 9.71193L13.3329 5.37033C13.1627 5.19825 12.888 5.19825 12.7178 5.37033C12.5477 5.54241 12.5477 5.82037 12.7178 5.99245L16.2901 9.60604H9.44217C4.84925 9.60604 1.11559 5.8292 1.11559 1.18316C1.11559 0.940484 0.919314 0.741935 0.679418 0.741935C0.439522 0.741935 0.243243 0.940484 0.243243 1.18316C0.243243 6.31454 4.36946 10.4885 9.44217 10.4885H16.2421L12.2686 14.508C12.0985 14.6801 12.0985 14.958 12.2686 15.1301C12.3558 15.2184 12.4649 15.2581 12.5783 15.2581C12.6917 15.2581 12.8007 15.2139 12.888 15.1301L17.6292 10.3341C17.7993 10.162 17.7993 9.88401 17.6292 9.71193H17.6248Z" fill="#7D7D7D"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.6292 9.71193C17.7993 9.88401 17.7993 10.162 17.6292 10.3341L12.888 15.1301C12.8007 15.2139 12.6917 15.2581 12.5783 15.2581C12.4649 15.2581 12.3558 15.2184 12.2686 15.1301C12.0985 14.958 12.0985 14.6801 12.2686 14.508L16.2421 10.4885H9.44217C4.36946 10.4885 0.243243 6.31454 0.243243 1.18316C0.243243 0.940484 0.439522 0.741935 0.679418 0.741935C0.919314 0.741935 1.11559 0.940484 1.11559 1.18316C1.11559 5.8292 4.84925 9.60604 9.44217 9.60604H16.2901L12.7178 5.99245C12.5477 5.82037 12.5477 5.54241 12.7178 5.37033C12.888 5.19825 13.1627 5.19825 13.3329 5.37033L17.6248 9.71193H17.6292ZM17.7268 9.47H17.7311L17.8026 9.54231C18.0658 9.80852 18.0658 10.2375 17.8026 10.5037L13.057 15.3042C12.9264 15.4297 12.7574 15.5 12.5783 15.5C12.4047 15.5 12.2315 15.4377 12.0951 15.2997C11.832 15.0335 11.832 14.6046 12.0951 14.3384L15.6618 10.7304H9.44217C4.23126 10.7304 0 6.44429 0 1.18316C0 0.810736 0.301325 0.5 0.679418 0.5C1.05751 0.5 1.35884 0.810736 1.35884 1.18316C1.35884 5.69945 4.98745 9.3641 9.44217 9.3641H15.7098L12.5444 6.16207C12.2812 5.89586 12.2812 5.46692 12.5444 5.20071C12.8098 4.93221 13.2409 4.93221 13.5063 5.20071L17.7268 9.47Z" fill="#7D7D7D"/>
                                </svg>
                                {{item.training_group}}
                            </span>
                            <span class="training-group" v-if="type=='trainings_deep'">
                                <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M17.6248 9.71193L13.3329 5.37033C13.1627 5.19825 12.888 5.19825 12.7178 5.37033C12.5477 5.54241 12.5477 5.82037 12.7178 5.99245L16.2901 9.60604H9.44217C4.84925 9.60604 1.11559 5.8292 1.11559 1.18316C1.11559 0.940484 0.919314 0.741935 0.679418 0.741935C0.439522 0.741935 0.243243 0.940484 0.243243 1.18316C0.243243 6.31454 4.36946 10.4885 9.44217 10.4885H16.2421L12.2686 14.508C12.0985 14.6801 12.0985 14.958 12.2686 15.1301C12.3558 15.2184 12.4649 15.2581 12.5783 15.2581C12.6917 15.2581 12.8007 15.2139 12.888 15.1301L17.6292 10.3341C17.7993 10.162 17.7993 9.88401 17.6292 9.71193H17.6248Z" fill="#7D7D7D"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.6292 9.71193C17.7993 9.88401 17.7993 10.162 17.6292 10.3341L12.888 15.1301C12.8007 15.2139 12.6917 15.2581 12.5783 15.2581C12.4649 15.2581 12.3558 15.2184 12.2686 15.1301C12.0985 14.958 12.0985 14.6801 12.2686 14.508L16.2421 10.4885H9.44217C4.36946 10.4885 0.243243 6.31454 0.243243 1.18316C0.243243 0.940484 0.439522 0.741935 0.679418 0.741935C0.919314 0.741935 1.11559 0.940484 1.11559 1.18316C1.11559 5.8292 4.84925 9.60604 9.44217 9.60604H16.2901L12.7178 5.99245C12.5477 5.82037 12.5477 5.54241 12.7178 5.37033C12.888 5.19825 13.1627 5.19825 13.3329 5.37033L17.6248 9.71193H17.6292ZM17.7268 9.47H17.7311L17.8026 9.54231C18.0658 9.80852 18.0658 10.2375 17.8026 10.5037L13.057 15.3042C12.9264 15.4297 12.7574 15.5 12.5783 15.5C12.4047 15.5 12.2315 15.4377 12.0951 15.2997C11.832 15.0335 11.832 14.6046 12.0951 14.3384L15.6618 10.7304H9.44217C4.23126 10.7304 0 6.44429 0 1.18316C0 0.810736 0.301325 0.5 0.679418 0.5C1.05751 0.5 1.35884 0.810736 1.35884 1.18316C1.35884 5.69945 4.98745 9.3641 9.44217 9.3641H15.7098L12.5444 6.16207C12.2812 5.89586 12.2812 5.46692 12.5444 5.20071C12.8098 4.93221 13.2409 4.93221 13.5063 5.20071L17.7268 9.47Z" fill="#7D7D7D"/>
                                </svg>
                                {{item.name}}
                            </span>
                        </div>
                    </div>
                    <div class="loading-trainings" v-if="all_trainings_deep_loaded || !deepSearchMode ? (i_t == 2 && loadingTrainings) : i_t == 1 && loadingTrainings">
                         <font-awesome-icon icon="spinner" />
                    </div>
                </div>
            </div>
        </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios'
import {getPalettes, getGroupHue} from "@/tools/colorPalettes.js"
import _ from 'lodash'
export default {
    props: {
        mode: {
            type: String,
        },
        deepSearchMode:{
            type: [Boolean, Number]
        }
    },
    data(){
        return{
            searchInput: '',
            dropdownOpen: false,
            items:{
                training_groups: [
                ],
                trainings:[
                ],
                trainings_deep:[]
            },
            maxHeight: 0,
            page: 1,
            loaded: 0,
            totalTrainingCount: 0,
            totalTrainingDeepCount: 0,
            colorPalettes: getPalettes(),
            editRoutes: ['edit', 'edit-group'],
            color1: "rgba(230, 69, 69, 1)",
            color2: "rgba(229, 115, 0, 1)",
            loadingTrainings:false,
            isHoveringDropdown: false,
            itemOrder: ['training_groups', 'trainings_deep', 'trainings'],
            loadedItems:{
                training_groups: false,
                trainings_deep: false,
                trainings: false
            },
            all_trainings_deep_loaded: false,
        }
    },
    watch:{
        searchInput(){
            this.page=1;
            this.items.trainings_deep = [];
            this.items.trainings = [];
            this.totalTrainingDeepCount = 0;
            this.all_trainings_deep_loaded = false
            this.debounceSearch();
        },
        deepSearchMode(){
            this.page=1;
            this.debounceSearch();
        }
    },
    mounted(){
        let container = this.$refs.searchContainer;
        let position = container.getBoundingClientRect();
        let top = position.top;
        this.maxHeight = (window.innerHeight - top)*0.8;
    },
    methods:{
        onScroll ({ target: { scrollTop, clientHeight, scrollHeight }}) {
            if (scrollTop + clientHeight >= scrollHeight) {
                this.loadMore()
            }
        },
        debounceSearch: _.debounce(function(){
            this.search();
        }, 500),
        search(page = 1){
            let input = this.searchInput;
            input = encodeURIComponent(input);
            let query = '';
            if(input.length > 0){
                query = '?q='+input+'&page='+page;
            }
            else{
                query = '?page='+page;
            }
            query+='&mode='+this.mode;
            query+='&all_trainings_deep_loaded='+this.all_trainings_deep_loaded;
            query+='&deep_search='+this.deepSearchMode;
            this.loadingTrainings=true;
            axios.get(`${this.$store.state.api_link}/training_group/search${query}`, this.$store.getters.axiosConfig())
                .then((res)=>{
                    if(!this.deepSearchMode){
                        this.items.trainings_deep = [];
                        this.totalTrainingDeepCount = 0
                    }
                    if(page == 1){
                        this.dropdownOpen = true;
                        this.items.training_groups = res.data.training_groups;
                        this.items.training_groups.forEach((group)=>{
                            group.color = getGroupHue(this.colorPalettes, group.color_slider_pos);
                        })
                        this.items.trainings = res.data.trainings;
                        if(this.all_trainings_deep_loaded || !this.deepSearchMode){
                            this.loaded = res.data.trainings.length;
                        }
                        else{
                            this.items.trainings_deep = res.data.trainings_deep;
                            this.loaded = res.data.trainings_deep.length;
                            this.totalTrainingDeepCount = res.data.total_training_deep_count;
                            setTimeout(() => {
                                if(this.$refs.dropdown && !this.hasVerticalScroll(this.$refs.dropdown) && (this.loaded != this.totalTrainingDeepCount)){
                                    this.loadMore()
                                }
                            },500)
                        }
                        this.totalTrainingCount = res.data.training_count;
                    }
                    else{
                        this.items.trainings = [...this.items.trainings, ...res.data.trainings];
                        if(this.all_trainings_deep_loaded || !this.deepSearchMode) {
                            this.loaded += res.data.trainings.length;
                        }
                        else{
                            this.loaded += res.data.trainings_deep.length;
                            this.items.trainings_deep = [...this.items.trainings_deep, ...res.data.trainings_deep];
                        }
                        

                    }
                    if(!this.all_trainings_deep_loaded && res.data.all_trainings_deep_loaded){
                        this.page = 1;
                        this.loaded = 0;
                        this.all_trainings_deep_loaded = res.data.all_trainings_deep_loaded
                    }
                    this.loadingTrainings=false;
                })
                .catch((err)=>{
                    this.loadingTrainings=false;
                    console.log(err);
                });
        },
        hasVerticalScroll(container) {
            return container.scrollHeight > container.clientHeight;
        },

        loadMore(){
            if(this.all_trainings_deep_loaded || !this.deepSearchMode){
                if(this.totalTrainingCount == null){
                    this.search(this.page);
                }
                else{
                    if(this.loaded < this.totalTrainingCount){
                        this.page++;
                        this.search(this.page);
                    }
                }
            }
            else{
                if(this.loaded < this.totalTrainingDeepCount){
                    this.page++;
                    this.search(this.page);
                }
            }
        },
        closeDropdown(){
            this.dropdownOpen=false
        },
        openDropdown(){
            if(this.items){
                if(this.items.trainings.length > 0 || this.items.training_groups.length > 0 || this.items.trainings_deep.length > 0){
                    this.dropdownOpen=true
                }
            }
        },
        openItem(item,type){
            if(type=='trainings' || type == 'trainings_deep'){
                if(this.editRoutes.includes(this.$route.name) && this.hasPermission('trainings.edit')){
                    if(item.matches){
                        this.editTraining(item, item.id, item.matches);
                    }else{
                        this.editTraining(item, item.id);
                    }
                }
                else{
                    this.openTraining(item, item.id, item.matches);
                }
            }
            else if(type=='training_groups'){
                this.openGroup(item.id)
            }
        },
        openTraining(item, id, matches=null){
            this.$store.state.loading.loadingStart();
            this.$store.state.previewMode = false;
            this.$store.state.currentTraining = id;
            this.$store.state.previewTopic = -1;
            if(item.new_training){
                this.$router.push("/edit-training-new/" + item.slug+'?mode=view');
            }
            else{
                if(matches){
                    this.$store.state.editTrainingPartIndex = matches[0].partIndex;
                    this.$router.push("/training?id=" + id +`#${matches[0].partIndex}`).catch(err => {});
                }else{
                    this.$router.push("/training?id=" + id).catch(err => {});
                }
            }

        },
        editTraining(item, id, matches=null){
            this.$store.state.loading.loadingStart();
            this.$store.state.currentTraining = id;
            this.$store.state.previewTopic = -1;
            if(matches){
                this.$store.state.editTrainingPartIndex = matches[0].partIndex;
            }
            if(item.new_training){
                this.$router.push("/edit-training-new/" + item.slug);
            }
            else{
                this.$router.push("/edit-training?id=" + id).catch(err => {});
            }
            
        },
        openGroup(id){
            this.$store.state.currentGroupOpen = id;
            if (id == -1) {
                this.$router.push("/bought-trainings");
            } else {
                if(this.editRoutes.includes(this.$route.name)){
                    this.$router.push("/edit-group?id=" + id).catch(err => {});
                }
                else{
                    this.$router.push("/group-trainings?id=" + id).catch(err => {});
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.search-container{
    display: flex;
    flex-direction: column;
    position: relative;
    width: 225px;
    z-index: 9;
    transition: width 0.3s;
    &.focused{
        width: 100%;
    }
    &:focus-within{
        width: 100%;
    }
    @media (max-width: 768px), (max-width: 1000px) and (max-height: 512px){
        width: 100%;
    }
}
input{
    padding: 4px 14px 4px 37px;
    padding-left: clamp(37px, 5vh, 40px);
    border-radius: 20px;
    background: #FFF;
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.16);
    color: #333;
    font-family: var(--main-site-font);
    font-size: clamp(16px, 2vh, 18px);
    font-style: normal;
    font-weight: 400;
    height: clamp(32px, 5vh, 38px);
    line-height: 24px; /* 150% */
    border:none;
    z-index: 2;
    width: 225px;

    transition: width 0.3s;
    &:focus{
        width: 100%;
        outline: 1px solid #CACACA;
        box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.16);

    }
    &.focused{
        width: 100%;
    }
}

.input-container{
    display: flex;
    align-items: center;
    position: relative;
    svg{
        position: absolute;
        z-index: 3;
        left: 14px;
        top: 0;
        bottom: 0;
        height: clamp(16px, 3vh, 18px);
        width: clamp(16px, 3vh, 18px);
        margin: auto;
    }
}
.dropdown-container{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    transform-origin: top;
    margin-top: 10px;
}
.dropdown-section{
    display: flex;
    flex-direction: column;
    &.bb-2{
        border-bottom: 2px solid #CACACA;
    }
}
.dropdown{
    border-radius: 16px;
    background: #FFF;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.20);
    padding: 30px 8px 8px 8px;
    overflow: auto;
    transition: box-shadow 0.3s;
}
.icon{
    display: flex;
    max-width: 60px;
    margin-right: 8px;
    width: 40px;
    min-width: 40px;
    height: 40px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 4px;
}
.item{
    display: flex;
    padding: 8px 0;
    max-height: 56px;
    align-items: center;
    cursor: pointer;
    &:hover{
        span{
            &:first-child{
                font-weight: 600;
            }
        }
    }
    p{
        margin: 0;
    }
}
.training-groups-section{
    .item{
        max-height: 48px;
    }
}
.content{
    display: flex;
    flex-direction: column;
    max-width: 100%;
    justify-content: flex-start;
    overflow: hidden;
    font-size: 14px;
    font-family: var(--main-site-font);
    color: #333;
    span{
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        &:first-child{
            margin-bottom: 4px;
        }
    }
}
.training-group{
    display: flex;
    align-items: center;
    color:#7D7D7D;
    svg{
        margin-right: 4px;
    }
}
.found-items{
    color: #7D7D7D;
    font-family: var(--main-site-font);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
    margin-top: 8px;
    margin-bottom: 8px;
}
.loading-trainings{
    display: flex;
    justify-content: center;
    align-items: center;
}
.slide-fade-enter-active {
  transition: all 0.25s ease;
}
.slide-fade-leave-active {
  transition: all 0.25s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: scaleY(0%);
  overflow: visible;
}
</style>